module.exports = __webpack_public_path__ + "static/img/100_own_emblem_rs3.5d743e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dist/100_own_emblem_rs3.png
// module id = QUOa
// module chunks = 1